import { useEffect, useState } from 'react'
import { bestScore, readAll, todayUTC } from '@/lib/history'
import { fetchPuzzleDates, formatDate } from '@/lib/puzzles'

export function Archive({ onClose }: { onClose: () => void }) {
  const [dates, setDates] = useState<string[] | null>(null)
  const [error, setError] = useState<string | null>(null)
  const history = readAll()
  const today = todayUTC()

  useEffect(() => {
    fetchPuzzleDates()
      .then(setDates)
      .catch(() => setError('The archive needs an internet connection.'))
  }, [])

  return (
    <div
      className="fixed inset-0 z-10 flex items-end justify-center bg-slate-950/50 p-4 sm:items-center"
      role="dialog"
      aria-modal="true"
      aria-labelledby="archive-title"
    >
      <div className="flex max-h-[85vh] w-full max-w-sm flex-col panel">
        <div className="flex items-center justify-between p-5 pb-3">
          <h2 id="archive-title" className="display text-xl">
            Past puzzles
          </h2>
          <button type="button" onClick={onClose} aria-label="Close" className="-m-1 p-1 text-2xl leading-none muted hover:opacity-70">
            ×
          </button>
        </div>
        <p className="px-5 text-xs muted">Scores join each day&apos;s scoreboard. Archive plays don&apos;t count toward your streak.</p>

        <ul className="mt-3 overflow-y-auto px-2 pb-3">
          {error && <li className="px-3 py-4 text-sm muted">{error}</li>}
          {!dates && !error && <li className="px-3 py-4 text-sm muted">Loading…</li>}
          {dates?.map((date) => {
            const record = history[date]
            const status = record?.finished
              ? `${bestScore(record)} pts`
              : record?.bestFound
                ? 'In progress'
                : 'Not played'
            return (
              <li key={date}>
                <a
                  href={date === today ? '/' : `/?date=${date}`}
                  className="flex items-center justify-between menu-item px-3 py-2.5"
                >
                  <span className="font-medium">
                    {date === today ? 'Today' : formatDate(date, { weekday: 'short', month: 'short', day: 'numeric' })}
                  </span>
                  <span className={record?.finished ? 'accent-text font-semibold' : 'muted text-sm'}>
                    {status}
                  </span>
                </a>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
